export enum EnumCadastrosMesas {
    Reconfigurar = 1,
    Adicionar = 2,
}